<template>
  <div
    class="hero-banner__spacer w-full xl:aspect-[16/7] bg-slate-800/10 pointer-events-none touch-none"
  ></div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
